import moment from 'moment'

export const formatDateText = (date: Date, timezone: string) => {
  const dateAsMoment = moment.tz(date, timezone)
  const today = moment().tz(timezone)
  const tomorrow = moment().tz(timezone).add(1, 'day')

  if (dateAsMoment.isSame(today, 'day')) return 'Today'
  if (dateAsMoment.isSame(tomorrow, 'day')) return 'Tomorrow'
  return dateAsMoment.format('ddd Do MMM')
}
